<div class="circle-delete"
    [style.left.px]=leftPosition
    [style.top.px]=topPosition
    style="margin-top: -24px;"
    ></div>
